function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}


function checkForSpecificQueries(q) {
  const queries = ["collab", "collaboration", "paid", "affiliate", "barter", "influencer", "marketing", "campaign", "partnership"];
  if(queries.includes(q)) {
    return true;
  }

  return false;
}

function changeLocation() {
  window.location.href = "https://www.vahdam.com/pages/affiliate";
  return;
}


docReady(doIt);
function doIt() {
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        // window.wizzyConfig.common.lazyDOMConfig.identifiersToClickOnSearch = ['button.wizzy-view-all-text']
        window.wizzyConfig["search"]["configs"]["pagination"][
          "infiniteScrollOffset"
        ] = { desktop: 5000, mobile: 2000 };
        
        window.wizzyConfig.common.lazyDOMConfig.identifiersToHideOnSearch.push(".cstm_hmlftsec");

        if(window.wizzyConfig.common.isOnProductViewPage === true) {
          window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push(".custom-product-wrapper");
        }else {
          window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("main");
        }
        return data;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (data) {
        var x = document.querySelector(".fc-widget-normal.fc-mobile-view");
        if (x !== null) {
          x.style.display = "none";
        }
        return data;
      }
    );


    document.querySelector("body").addEventListener("click", function(event) {
      if(event.target.classList.contains("wizzy-view-all-text")) {
        var x = document.querySelector(".SearchField-form");
        if(x !== undefined || x !== null) {
          if(x.classList.contains("has-value")) {
            x.submit();
          }else {
            window.location.href = window.location.origin + "/collections/best-sellers";
          }
        }
      }
    });
  
    // window.wizzyConfig.events.registerEvent(
    //   window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    //   function (data) {
    //     document.querySelector("p.wizzy-view-all-text").addEventListener("click", function(event) {
    //       if(document.documentElement.clientWidth > 768) {
    //         document.querySelectorAll("#wizzySearchFormWorking")[0].submit();
    //       }else {
    //         document.querySelectorAll("#wizzySearchForm")[0].submit();
    //       }
    //     });
    //     return data;
    //   }
    // );


    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
      function (data) {
        // var searchBox = document.getElementById("wizzySearchFormWorking");
        // searchBox.style.display = "none";
        // searchBox.classList.remove("toggle-searchbar");
        // searchBox.style.display = "none";
        return data;
      }
    );


    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, 
      function (data) {
        
        let x = document.querySelectorAll(".Offcanvas-bgDimmer")[0];
        if(x) { x.click(); }

        if(data.q) {
          if(checkForSpecificQueries(data.q.toLowerCase())) {
            changeLocation();
            throw new Error("Execution stopped");
          }
        }
        
        return data;
    });

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
      function (data) {
        var body = document.querySelector("body");
        // if (body.classList.contains("has-open-offcanvas")) {
        //   body.classList.remove("has-open-offcanvas");
        // }

        let n = data.length;
        let m;
        for (let i = 0; i < n; i++) {
          m = data[i].attributes.length;
          for (let j = 0; j < m; j++) {
            if (data[i].attributes[j].id === "product_badge_judgeme") {
              const htmlString = data[i].attributes[j].values[0].value[0]
              const tempElement = document.createElement('div');
              tempElement.innerHTML = htmlString;
              
              // Get the div element with the class 'jdgm-prev-badge'
              const divElement = tempElement.querySelector('.jdgm-prev-badge');
              
              // Get the value of 'data-average-rating' attribute
              const dataAverageRating = divElement.getAttribute('data-average-rating');
              data[i].avgRatings = dataAverageRating;
                
              data[i].reviewHTML = data[i].attributes[j].values[0].value[0];
            } else if (data[i].attributes[j].id === "product_variant_ids") {
              data[i].variantId = data[i].attributes[j].values[0].value[0];
            }else if(data[i].attributes[j].id === "product_p_subtitle_airf") {
              var valueOfSubtital = data[i].attributes[j].values[0].value[0]; 
              if(valueOfSubtital !== "&nbsp") {
                data[i].subTitle = valueOfSubtital;
              }
            }
          }
        }

        return data;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
      function (data) {
        let n = data.response.payload.facets.length;
        for (let i = 0; i < n; i++) {
          let m = data.response.payload.facets[i].data.length;
          for (let j = 0; j < m; j++) {
            data.response.payload.facets[i].data[j].label = data.response.payload.facets[i].data[j].label.split("-").join(" ");
            let temp = data.response.payload.facets[i].data[j].label;
            data.response.payload.facets[i].data[j].label = temp.charAt(0).toUpperCase() + temp.slice(1);
          }
        }
        return data;
      }
    );

    document.querySelector("body").addEventListener("click", function (event) {
      if (event.target.classList.contains("autocomplete-text-wrapper")) {
        if (document.documentElement.clientWidth < 768) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          var query = event.target.parentNode.getAttribute("data-searchterm");
          document.querySelectorAll(".SearchField-field")[0].value = query;
          document.querySelectorAll(".SearchField-field")[0].focus();
        }
      }
    });

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutationRecord) {
          if(mutationRecord != null && mutationRecord.target.classList.contains("is-expanded")) {
            document.querySelectorAll(".SearchField-field")[0].click();
            document.querySelectorAll(".SearchField-field")[0].focus();
          }
        });    
    });
    
    var target = document.querySelectorAll('.SearchField')[0];
    observer.observe(target, { attributes : true, attributeFilter : ['class'] });
    
    changeTemplate("wizzy-search-results-product");
    changeTemplate("wizzy-search-results");
    changeTemplate("wizzy-autocomplete-topproducts");
}


const changeTemplate = (div) => {
  const newDiv = document.getElementById(div + "-new").text;
  const oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};
